<span class="badge" [ngClass]="statut.code">{{statut.libelle}}</span>